const HideableTabPanel = (props: {
  children: React.ReactNode;
  index: string | false;
  value: string | false;
}): React.ReactElement => {
  return (
    <div role="tabpanel" hidden={props.value !== props.index}>
      {props.children}
    </div>
  );
};

export default HideableTabPanel;
